// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1u_bQ","newExpiryDate":"styles_newExpiryDate__2BdnD","footer":"styles_footer__3edop"};